/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BodyMetric } from '../models';
// @ts-ignore
import type { BodyMetricCreateRequest } from '../models';
// @ts-ignore
import type { BodyMetricStatsResponse } from '../models';
// @ts-ignore
import type { BodyMetricUpdateRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListBodyMetrics200Response } from '../models';
// @ts-ignore
import type { SyncResponse } from '../models';
// @ts-ignore
import type { UploadParseResponse } from '../models';
/**
 * BodyMetricApi - axios parameter creator
 * @export
 */
export const BodyMetricApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create body metric
         * @param {BodyMetricCreateRequest} bodyMetricCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBodyMetric: async (bodyMetricCreateRequest: BodyMetricCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyMetricCreateRequest' is not null or undefined
            assertParamExists('createBodyMetric', 'bodyMetricCreateRequest', bodyMetricCreateRequest)
            const localVarPath = `/api/health/body-metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyMetricCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a body metric
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBodyMetric: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBodyMetric', 'id', id)
            const localVarPath = `/api/health/body-metrics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a body metric by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBodyMetric: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBodyMetric', 'id', id)
            const localVarPath = `/api/health/body-metrics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get body metric statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBodyMetricStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/body-metrics/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest body metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestBodyMetric: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/body-metrics/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List body metrics
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBodyMetrics: async (cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/body-metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk sync body metrics
         * @param {Array<BodyMetric>} bodyMetric 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncBodyMetrics: async (bodyMetric: Array<BodyMetric>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyMetric' is not null or undefined
            assertParamExists('syncBodyMetrics', 'bodyMetric', bodyMetric)
            const localVarPath = `/api/health/body-metrics/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyMetric, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a body metric
         * @param {string} id 
         * @param {BodyMetricUpdateRequest} bodyMetricUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBodyMetric: async (id: string, bodyMetricUpdateRequest: BodyMetricUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBodyMetric', 'id', id)
            // verify required parameter 'bodyMetricUpdateRequest' is not null or undefined
            assertParamExists('updateBodyMetric', 'bodyMetricUpdateRequest', bodyMetricUpdateRequest)
            const localVarPath = `/api/health/body-metrics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyMetricUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload body-scale screenshot for OCR parsing (returns parsed metric, not saved)
         * @param {File} file .jpg / .jpeg / .png / .heic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBodyImage: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadBodyImage', 'file', file)
            const localVarPath = `/api/health/upload/body`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BodyMetricApi - functional programming interface
 * @export
 */
export const BodyMetricApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BodyMetricApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create body metric
         * @param {BodyMetricCreateRequest} bodyMetricCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBodyMetric(bodyMetricCreateRequest: BodyMetricCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBodyMetric(bodyMetricCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.createBodyMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a body metric
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBodyMetric(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBodyMetric(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.deleteBodyMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a body metric by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBodyMetric(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBodyMetric(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.getBodyMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get body metric statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBodyMetricStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyMetricStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBodyMetricStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.getBodyMetricStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get latest body metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestBodyMetric(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestBodyMetric(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.getLatestBodyMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List body metrics
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBodyMetrics(cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBodyMetrics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBodyMetrics(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.listBodyMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk sync body metrics
         * @param {Array<BodyMetric>} bodyMetric 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncBodyMetrics(bodyMetric: Array<BodyMetric>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncBodyMetrics(bodyMetric, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.syncBodyMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a body metric
         * @param {string} id 
         * @param {BodyMetricUpdateRequest} bodyMetricUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBodyMetric(id: string, bodyMetricUpdateRequest: BodyMetricUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBodyMetric(id, bodyMetricUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.updateBodyMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload body-scale screenshot for OCR parsing (returns parsed metric, not saved)
         * @param {File} file .jpg / .jpeg / .png / .heic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBodyImage(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadParseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBodyImage(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BodyMetricApi.uploadBodyImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BodyMetricApi - factory interface
 * @export
 */
export const BodyMetricApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BodyMetricApiFp(configuration)
    return {
        /**
         * 
         * @summary Create body metric
         * @param {BodyMetricApiCreateBodyMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBodyMetric(requestParameters: BodyMetricApiCreateBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric> {
            return localVarFp.createBodyMetric(requestParameters.bodyMetricCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a body metric
         * @param {BodyMetricApiDeleteBodyMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBodyMetric(requestParameters: BodyMetricApiDeleteBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBodyMetric(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a body metric by id
         * @param {BodyMetricApiGetBodyMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBodyMetric(requestParameters: BodyMetricApiGetBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric> {
            return localVarFp.getBodyMetric(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get body metric statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBodyMetricStats(options?: RawAxiosRequestConfig): AxiosPromise<BodyMetricStatsResponse> {
            return localVarFp.getBodyMetricStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest body metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestBodyMetric(options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric> {
            return localVarFp.getLatestBodyMetric(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List body metrics
         * @param {BodyMetricApiListBodyMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBodyMetrics(requestParameters: BodyMetricApiListBodyMetricsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListBodyMetrics200Response> {
            return localVarFp.listBodyMetrics(requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk sync body metrics
         * @param {BodyMetricApiSyncBodyMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncBodyMetrics(requestParameters: BodyMetricApiSyncBodyMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncResponse> {
            return localVarFp.syncBodyMetrics(requestParameters.bodyMetric, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a body metric
         * @param {BodyMetricApiUpdateBodyMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBodyMetric(requestParameters: BodyMetricApiUpdateBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric> {
            return localVarFp.updateBodyMetric(requestParameters.id, requestParameters.bodyMetricUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload body-scale screenshot for OCR parsing (returns parsed metric, not saved)
         * @param {BodyMetricApiUploadBodyImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBodyImage(requestParameters: BodyMetricApiUploadBodyImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadParseResponse> {
            return localVarFp.uploadBodyImage(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BodyMetricApi - interface
 * @export
 * @interface BodyMetricApi
 */
export interface BodyMetricApiInterface {
    /**
     * 
     * @summary Create body metric
     * @param {BodyMetricApiCreateBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    createBodyMetric(requestParameters: BodyMetricApiCreateBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric>;

    /**
     * 
     * @summary Delete a body metric
     * @param {BodyMetricApiDeleteBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    deleteBodyMetric(requestParameters: BodyMetricApiDeleteBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a body metric by id
     * @param {BodyMetricApiGetBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    getBodyMetric(requestParameters: BodyMetricApiGetBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric>;

    /**
     * 
     * @summary Get body metric statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    getBodyMetricStats(options?: RawAxiosRequestConfig): AxiosPromise<BodyMetricStatsResponse>;

    /**
     * 
     * @summary Get latest body metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    getLatestBodyMetric(options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric>;

    /**
     * 
     * @summary List body metrics
     * @param {BodyMetricApiListBodyMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    listBodyMetrics(requestParameters?: BodyMetricApiListBodyMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListBodyMetrics200Response>;

    /**
     * 
     * @summary Bulk sync body metrics
     * @param {BodyMetricApiSyncBodyMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    syncBodyMetrics(requestParameters: BodyMetricApiSyncBodyMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncResponse>;

    /**
     * 
     * @summary Update a body metric
     * @param {BodyMetricApiUpdateBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    updateBodyMetric(requestParameters: BodyMetricApiUpdateBodyMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<BodyMetric>;

    /**
     * 
     * @summary Upload body-scale screenshot for OCR parsing (returns parsed metric, not saved)
     * @param {BodyMetricApiUploadBodyImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApiInterface
     */
    uploadBodyImage(requestParameters: BodyMetricApiUploadBodyImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadParseResponse>;

}

/**
 * Request parameters for createBodyMetric operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiCreateBodyMetricRequest
 */
export interface BodyMetricApiCreateBodyMetricRequest {
    /**
     * 
     * @type {BodyMetricCreateRequest}
     * @memberof BodyMetricApiCreateBodyMetric
     */
    readonly bodyMetricCreateRequest: BodyMetricCreateRequest
}

/**
 * Request parameters for deleteBodyMetric operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiDeleteBodyMetricRequest
 */
export interface BodyMetricApiDeleteBodyMetricRequest {
    /**
     * 
     * @type {string}
     * @memberof BodyMetricApiDeleteBodyMetric
     */
    readonly id: string
}

/**
 * Request parameters for getBodyMetric operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiGetBodyMetricRequest
 */
export interface BodyMetricApiGetBodyMetricRequest {
    /**
     * 
     * @type {string}
     * @memberof BodyMetricApiGetBodyMetric
     */
    readonly id: string
}

/**
 * Request parameters for listBodyMetrics operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiListBodyMetricsRequest
 */
export interface BodyMetricApiListBodyMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof BodyMetricApiListBodyMetrics
     */
    readonly cursor?: string

    /**
     * 
     * @type {number}
     * @memberof BodyMetricApiListBodyMetrics
     */
    readonly limit?: number
}

/**
 * Request parameters for syncBodyMetrics operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiSyncBodyMetricsRequest
 */
export interface BodyMetricApiSyncBodyMetricsRequest {
    /**
     * 
     * @type {Array<BodyMetric>}
     * @memberof BodyMetricApiSyncBodyMetrics
     */
    readonly bodyMetric: Array<BodyMetric>
}

/**
 * Request parameters for updateBodyMetric operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiUpdateBodyMetricRequest
 */
export interface BodyMetricApiUpdateBodyMetricRequest {
    /**
     * 
     * @type {string}
     * @memberof BodyMetricApiUpdateBodyMetric
     */
    readonly id: string

    /**
     * 
     * @type {BodyMetricUpdateRequest}
     * @memberof BodyMetricApiUpdateBodyMetric
     */
    readonly bodyMetricUpdateRequest: BodyMetricUpdateRequest
}

/**
 * Request parameters for uploadBodyImage operation in BodyMetricApi.
 * @export
 * @interface BodyMetricApiUploadBodyImageRequest
 */
export interface BodyMetricApiUploadBodyImageRequest {
    /**
     * .jpg / .jpeg / .png / .heic
     * @type {File}
     * @memberof BodyMetricApiUploadBodyImage
     */
    readonly file: File
}

/**
 * BodyMetricApi - object-oriented interface
 * @export
 * @class BodyMetricApi
 * @extends {BaseAPI}
 */
export class BodyMetricApi extends BaseAPI implements BodyMetricApiInterface {
    /**
     * 
     * @summary Create body metric
     * @param {BodyMetricApiCreateBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public createBodyMetric(requestParameters: BodyMetricApiCreateBodyMetricRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).createBodyMetric(requestParameters.bodyMetricCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a body metric
     * @param {BodyMetricApiDeleteBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public deleteBodyMetric(requestParameters: BodyMetricApiDeleteBodyMetricRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).deleteBodyMetric(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a body metric by id
     * @param {BodyMetricApiGetBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public getBodyMetric(requestParameters: BodyMetricApiGetBodyMetricRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).getBodyMetric(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get body metric statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public getBodyMetricStats(options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).getBodyMetricStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest body metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public getLatestBodyMetric(options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).getLatestBodyMetric(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List body metrics
     * @param {BodyMetricApiListBodyMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public listBodyMetrics(requestParameters: BodyMetricApiListBodyMetricsRequest = {}, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).listBodyMetrics(requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk sync body metrics
     * @param {BodyMetricApiSyncBodyMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public syncBodyMetrics(requestParameters: BodyMetricApiSyncBodyMetricsRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).syncBodyMetrics(requestParameters.bodyMetric, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a body metric
     * @param {BodyMetricApiUpdateBodyMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public updateBodyMetric(requestParameters: BodyMetricApiUpdateBodyMetricRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).updateBodyMetric(requestParameters.id, requestParameters.bodyMetricUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload body-scale screenshot for OCR parsing (returns parsed metric, not saved)
     * @param {BodyMetricApiUploadBodyImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BodyMetricApi
     */
    public uploadBodyImage(requestParameters: BodyMetricApiUploadBodyImageRequest, options?: RawAxiosRequestConfig) {
        return BodyMetricApiFp(this.configuration).uploadBodyImage(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

